module.exports = __webpack_public_path__ + "static/media/beck.c1d19e56.mp3";